import NotificationActions from '../../actions/NotificationActions';

import NotificationStore from '../../stores/NotificationStore';

import Note from './Note.react';
import NoteFullscreen from './NoteFullscreen.react';

class Notification extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            notifications : []
        };

        this.onNotificationStoreChange = this.onNotificationStoreChange.bind(this);
    }

    componentDidMount() {
        NotificationStore.addChangeListener(this.onNotificationStoreChange);
    }

    componentWillUnmount() {
        NotificationStore.removeChangeListener(this.onNotificationStoreChange);
    }

    onNotificationStoreChange() {
        this.setState({ notifications : NotificationStore.getState().notifications });
    }

    removeNotification() {
        NotificationActions.removeNotification();
    }

    render() {
        var notifications = this.state.notifications;

        return (
            <div className='notification'>

                {this.state.notifications.map((note, i) => {

                    if (!note.show)
                        return null;

                    if (note.fullscreen)
                        return (
                            <NoteFullscreen
                                note={note}
                                key={note.uuid} />
                        );

                    return (
                        <Note
                            automationId={'notification_note_'+i}
                            note={note}
                            key={note.uuid} />
                    );
                })}
            </div>
        );
    }
}

export default Notification;



// WEBPACK FOOTER //
// ./ui_src/app/components/notification/Notification.react.jsx